module.exports = __webpack_public_path__ + "static/media/ecoBike.409414ac.png";